import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { fetchFailedCampaignPayments } from 'api/campaignApi';
import { currentUser } from 'store/authSlice';
import { CompaniesSelectors, getCompanies } from 'store/companiesSlice';
import {
  getPendingCampaigns,
  MenuCampaignsSelectors,
} from 'store/menuCampaignsSlice';
import { openNotification } from 'store/notificationSlice';

const useAppInit = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isUserLoaded = useSelector((state) => state.auth.isLoaded);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!isUserLoaded) {
      dispatch(currentUser());
    }
  }, [dispatch, isUserLoaded, isLoggedIn, location.pathname]);

  const isMenuCampaignsLoaded = useSelector(MenuCampaignsSelectors.isLoaded);
  const isMenuCampaignsLoading = useSelector(MenuCampaignsSelectors.isLoading);

  useEffect(() => {
    if (isLoggedIn && !isMenuCampaignsLoaded && !isMenuCampaignsLoading) {
      dispatch(getPendingCampaigns());
    }
  }, [dispatch, isLoggedIn, isMenuCampaignsLoaded, isMenuCampaignsLoading]);

  const hasCompany = useSelector(CompaniesSelectors.all).length > 0;
  const isCompaniesLoaded = useSelector(CompaniesSelectors.isLoaded);
  const isCompaniesLoading = useSelector(CompaniesSelectors.isLoading);

  useEffect(() => {
    if (
      isLoggedIn &&
      isUserLoaded &&
      !isCompaniesLoaded &&
      !isCompaniesLoading
    ) {
      dispatch(getCompanies());
    }

    if (
      isLoggedIn &&
      isCompaniesLoaded &&
      !hasCompany &&
      location.pathname !== '/setup-company'
    ) {
      navigate('/setup-company');
    }

    if (isCompaniesLoaded && hasCompany) {
      localStorage.setItem('hasCompany', true);
    }

    if (isLoggedIn && isCompaniesLoaded && !hasCompany) {
      localStorage.setItem('hasCompany', false);
    }
  }, [dispatch, isLoggedIn, isCompaniesLoaded, hasCompany, isUserLoaded]);

  useEffect(() => {
    if (isLoggedIn && isUserLoaded) {
      const checkForFailedCampaignPayments = async () => {
        const failedPayment = await fetchFailedCampaignPayments();

        if (failedPayment) {
          dispatch(
            openNotification({
              isPaymentFailed: true,
            })
          );
        }
      };

      checkForFailedCampaignPayments();
    }
  }, [dispatch, isLoggedIn, isUserLoaded]);
};

export default useAppInit;
